import { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VisitorCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const trackAndGetCount = async () => {
      try {
        // Check if this browser has already been counted
        const hasBeenCounted = localStorage.getItem('mgn_visitor_counted');
        
        if (!hasBeenCounted) {
          // First visit from this browser - track it
          const response = await axios.post(`${API}/visitor/track`);
          setCount(response.data.total_visitors);
          // Mark this browser as counted
          localStorage.setItem('mgn_visitor_counted', 'true');
        } else {
          // Already counted - just get the current count without incrementing
          const countResponse = await axios.get(`${API}/visitor/count`);
          setCount(countResponse.data.total_visitors);
        }
      } catch (error) {
        console.error('Failed to track visitor:', error);
        // Try to at least get the count
        try {
          const countResponse = await axios.get(`${API}/visitor/count`);
          setCount(countResponse.data.total_visitors);
        } catch (e) {
          console.error('Failed to get visitor count:', e);
        }
      }
    };

    trackAndGetCount();
  }, []);

  if (count === null) return null;

  return (
    <div 
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary/10 border border-secondary/30 text-sm"
      data-testid="visitor-counter"
    >
      <Users className="w-4 h-4 text-secondary" />
      <span className="text-muted-foreground">
        <span className="font-bold text-secondary">{count.toLocaleString()}</span> visitors
      </span>
    </div>
  );
}
